<template>
  <div>
    <!-- 审批 -->
    <el-form :model="examineForm" ref="examineForm" :rules="examineRules" label-width="110px" class="all-form" size="small" 
      style="padding-right: 0" v-if="editType=='examine'">
      <el-form-item :label="Language('审批状态')" prop="checkRes">
        <el-select v-model="examineForm.checkRes" :placeholder="Language('审批状态')" clearable filterable>
          <el-option :label="Language('通过')" value="1"></el-option>
          <el-option :label="Language('不通过')" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="Language(examineForm.checkRes==2?'不通过原因':'审批内容')" prop="checkRemark">
        <el-input type="textarea" v-model.trim="examineForm.checkRemark" :placeholder="examineForm.checkRes==2?'请输入不通过原因':'请输入审批内容'" :rows="4"></el-input>
      </el-form-item>
      <el-form-item v-if="editType=='examine'">
        <el-button type="primary" @click="handleExamineFn">{{Language('提交审批')}}</el-button>
      </el-form-item>
    </el-form>
    
    <!-- 回访 -->
    <ReturnVisit v-if="editType=='return'" @closePageView="closePageView" :returnId="returnId"></ReturnVisit>

    <el-form :model="sForm" ref="sForm" :rules="rules" label-width="110px" class="all-form" size="small" style="padding-right: 0">
      <!-- 工单固定字段 -->
      <el-form-item prop="title" :label="Language('标题')" style="display:block;width: 100%;">
        <el-input v-model.trim="sForm.title" clearable :placeholder="Language('请输入标题')" maxlength="50" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-input>
      </el-form-item>
      <el-form-item prop="orderTypeCode" :label="Language('工单类型')" style="display:inline-block;width: 50%;margin-right: -5px">
        <el-select v-model="sForm.orderTypeCode" :placeholder="Language('请选择工单类型')" style="width:100%" @change="orderTypeCodeChangeFn" :disabled="editType=='examine'||editType=='info'||editType=='return'" clearable filterable>
          <el-option v-for="item in optionList['orderType']" :key="item.code" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="formId" :label="Language('表单名称')" style="display:inline-block;width: 50%;">
        <el-select v-model="sForm.formId" placeholder="请选择表单名称" style="width:100%" :disabled="editType=='examine'||editType=='info'||editType=='return'" clearable filterable>
          <el-option v-for="item in orderFormOption.filter(item => { return item.isValid==1 })" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <!-- 配置字段 -->
      <el-form-item :prop="item.fieldName" :rules="item.isRequired==1 ? rulesFunc(item):[{required: false}]" :key="index" :style="getStyle(item)"
        class="mb15" v-for="(item,index) in formColumnList.filter(item => { return item.fieldName!='title'&&item.fieldName!='orderTypeCode'&&item.fieldName!='formId'&&item.fieldName!='cusId'&&item.fieldName!='isReceiveOverTime'&&item.fieldName!='sourceId'})">
        <span slot="label">{{item.fieldCnName}}</span>
        <!-- 日期时间范围选择 -->
        <el-date-picker v-if="item.inputType === 'datetimerange'" :disabled="editType=='examine'||editType=='info'||editType=='return'"
          style="width:100%;" v-model="datetimerangeObj[item.fieldName]" type="datetimerange" range-separator="~" 
          :start-placeholder="Language('开始日期')" :end-placeholder="Language('结束日期')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <!-- date -->
        <el-date-picker v-else-if="item.inputType == 'date'" :disabled="editType=='examine'||editType=='info'||editType=='return'"
          style="width:100%;" v-model="sForm[item.fieldName]" type="date" :placeholder="Language('请选择')+item.fieldCnName"></el-date-picker>
        <!-- time -->
        <el-date-picker v-else-if="item.inputType == 'time'" :disabled="editType=='examine'||editType=='info'||editType=='return'"
          style="width:100%;" v-model="sForm[item.fieldName]" type="time" :placeholder="Language('请选择')+item.fieldCnName"></el-date-picker>
        <!-- datetime -->
        <el-date-picker v-else-if="item.inputType == 'datetime' ||  item.inputType == 'datetime'" :disabled="editType=='examine'||editType=='info'||editType=='return'"
          style="width:100%;" v-model="sForm[item.fieldName]" type="datetime" :placeholder="Language('请选择')+item.fieldCnName"></el-date-picker>
        <!-- 开关 -->
        <el-switch v-else-if="item.fieldName === 'isOverTime' || item.fieldName === 'isWheelOverTime' || item.fieldName === 'isTipsCus' || item.fieldName === 'isReceiveOverTime'
          || item.fieldName === 'isVisit' || item.fieldName === 'isBeVisit' || item.fieldName === 'isSolved' || item.fieldName === 'isSat'"
          v-model="sForm[item.fieldName]" :active-value="'1'" :inactive-value="'0'" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-switch>
        <!-- 单选框、多选框 -->
        <RadioCheckBox v-else-if="item.inputType=='radio'||item.inputType=='checkbox'" :ref="item.fieldName" :dataOrigin="item.dataOrigin"
          :inputType="item.inputType" :fieldName="item.fieldName" :editType="editType" :filterData="filterData[item.dataOrigin]"></RadioCheckBox>
        <!-- 选择框 -->
        <SelectList v-else-if="item.inputType=='select'||item.inputType=='personnelSelect'||item.fieldName=='groupId'||item.fieldName=='userId'"
          :placeholderLoad="item.fieldCnName" :dataMultiple="item.selectType" :ref="item.fieldName" :dataOrigin="item.dataOrigin"
          :inputType="item.inputType" :fieldName="item.fieldName" :editType="editType" :orderStatus="sFormInfo.status" style="width:100%;"
          @orderFormDesignGetListFn="orderFormDesignGetListFn" @changeOrgFn="changeOrgFn" :filterData="filterData[item.dataOrigin]" 
          @originTypeChange="originTypeChange" @priorityCodeChange="priorityCodeChange"></SelectList>
        <!-- 级联选择 -->
        <CascaderList style="width:100%;" :checkStrictly="item.cascadeType==1?true:false" v-else-if="item.inputType === 'cascader'"
          :placeholderLoad="item.fieldCnName" :ref="item.fieldName" :dataOrigin="item.dataOrigin" :editType="editType"></CascaderList>
        <!-- 工单内容、处理内容 -->
        <div v-else-if="item.inputType==='textarea'&& (item.fieldName=='content'||item.fieldName=='handleContent')">
          <el-popover placement="bottom-start" width="300" trigger="click" :ref="item.fieldName">
            <el-tree :data="modelCfgList.filter(mItem => { 
              if (item.fieldName == 'content') return mItem.modelType==1 && mItem.orderTypeCode==sForm.orderTypeCode
              else return mItem.modelType==2 && mItem.orderTypeCode==sForm.orderTypeCode
              })" :props="{children: 'children', label: 'name'}"
              @node-click="(data, node, obj) => handleNodeClick(data, node, obj, item.fieldName)"></el-tree>
            <el-button type="text" size="mini" slot="reference" @click="orderModelCfgGetListFn" :disabled="editType=='examine'||editType=='info'||editType=='return'">
              <i class="iconfont iconny-027xuanzemoban text-middle mr-5"></i>{{Language(item.fieldName=='content'?'选择工单登记':'选择工单回复')}}
            </el-button>
          </el-popover>
          <el-input style="width:100%" type="textarea" :rows="4" v-model="sForm[item.fieldName]" :placeholder="Language('请输入')+item.fieldCnName" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-input>
        </div>
        <!-- 会话标签 -->
        <div v-else-if="item.fieldName == 'labMsg'">
          <div class="label-list" v-if="sessLabPath&&sessLabPath.length" :ref="item.fieldName">
            <el-tag type="success" size="small" v-for="(item, index) in sessLabPath" :key="index" closable @close="removeSessionLab(item, index)" v-if="editType!='examine'&&editType!='info'&&editType!='return'">{{item.LabPath}}</el-tag>
          </div>
          <el-button type="text" @click="sessionLabVisible=true" :disabled="editType=='examine'||editType=='info'||editType=='return'">{{Language(sessLabPath.length?'继续选择':'选择标签')}}</el-button>
        </div>
        <!-- 上传附件 -->
        <div v-else-if="item.inputType === 'input' && item.fieldCnName == '上传附件'">
          <div class="linkStyle" style="height:auto;line-height:normal;">
            <el-upload class="avatar-uploader" ref="uploadFile" action="null" :multiple="true" :http-request="handleUploadHttpRequest"
              :before-upload="handleBeforeUpload" :on-change="handleUploadChange" :show-file-list="false" accept="*" :disabled="editType=='examine'||editType=='info'||editType=='return'">
              <el-button slot="trigger" type="text" :disabled="editType=='examine'||editType=='info'||editType=='return'">{{Language(fileList.length?'继续添加':'添加附件')}}</el-button>
            </el-upload>
            <ul class="fileList" v-if="fileList != null">
              <li v-for="(item, index) in fileList" :key="index">
                <i class="iconfont iconlianjie fileIcon"></i>
                <a type="primary" :href="item.path" :download="item.name" target="_blank" style="color: #409EFF">{{item.name}}</a>
                <i class="el-icon-delete-solid fileDel" @click="fileDeleteFn(index)" v-if="editType!='examine'&&editType!='info'&&editType!='return'"></i>
              </li>
            </ul>
          </div>
        </div>
        <!-- 级联选择 -->
        <el-input style="width:100%" v-else-if="item.inputType === 'textarea'" type="textarea" v-model.trim="sForm[item.fieldName]" 
          :placeholder="Language('请输入')+item.fieldCnName" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-input>
        <!-- 数字框 -->
        <el-input-number v-model="sForm[item.fieldName]" style="width:150px" v-else-if="item.inputType === 'number'" controls-position="right" 
         :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-input-number>
        <!-- 人员部门选择框 -->
        <DepartPersonSelect v-else-if="item.inputType === 'departmentSelect'" :ref="item.fieldName" :editType="editType"></DepartPersonSelect>
        <!-- 输入框 -->
        <el-input style="width:100%" v-else v-model.trim="sForm[item.fieldName]" clearable :placeholder="Language('请输入')+item.fieldCnName" 
          :disabled="editType=='examine'||editType=='info'||editType=='return'||((item.fieldName=='vId'||item.fieldName=='nikeName'||item.fieldName=='sourceId')&&((sFormInfo.status&&sFormInfo.status!='0')||editType=='hotline'))"></el-input>
      </el-form-item>
      <!-- 是否解决 -->
      <el-form-item prop="solveSelf" :label="Language('是否解决')" v-if="editType=='add'||editType=='hotline'||(editType=='edit'&&sFormInfo['status']==0)">
        <el-switch v-model="sForm.solveSelf" :active-value="'1'" :inactive-value="'0'" @change="changeCloseFn"></el-switch>
      </el-form-item>
      <el-row v-if="sFormInfo.status!=8 && editType!='examine' && editType!='info' && editType!='return'">
        <el-form-item>
          <el-button type="success" @click="saveFn(1)" v-if="(editType=='add'||sFormInfo['status']==0)||(editType=='hotline'&&!isHotlineSubmit)" :loading="submitLoading">{{Language('暂 存')}}</el-button>
          <el-button type="primary" @click="saveFn" :loading="submitLoading">{{Language('提 交')}}</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    
    <!-- 会话标签 -->
    <el-dialog class="orderSessionLab" :title="Language('会话标签')" ref="orderSessionLab" width="60%" :visible.sync="sessionLabVisible" 
      :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false">
      <Sessionlab @submitLabFn="fetchLablistFn" v-if="sessionLabVisible" pageType="SASS" :sessLabPath="sessLabPath"></Sessionlab>
    </el-dialog>
  </div>
</template>

<script>
  import { orderGetInfo, orderUploadFile, getAttList } from "@/http/orderManagement.js"
  import { perHandleManCfgGetCfgInfo } from "@/http/perHandleManCfg.js"
  import { getOrgData } from "@/http/UserManagement.js"
  import { orderExtensionApplyHandle } from "@/http/orderExamine.js"
	import { getDictMap } from '@/http/BaseData.js'
  import { orderModelCfgGetList } from "@/http/orderModelCfgManagement.js"
  import { getFormColumnList } from '@/http/Customfield.js'
	import SelectList from './SelectList'
	import RadioCheckBox from './RadioCheckBox'
	import CascaderList from './CascaderList'
	import DepartPersonSelect from './DepartPersonSelect'
	import ReturnVisit from './ReturnVisit'
  import Sessionlab from '@/views/components/SessionLab'

  export default {
    name: "customerManagement",
    props: { 
      hotlineObj: Object, //弹屏带过来的参数
      dialogShow: Boolean, //显示二级页面
      editType: String, //修改类型 info：查看 add：新增 edit：编辑 examine：审批 supervise：督办 hotline：弹屏
      examineId: String, //审批id
      returnId: String, //满意度评价记录ID
      sFormInfo: { 
        type: Object, default: function() {
          return {}
        }, required: false
      },
      orderId: { 
        type: String, default: function() {
          return ''
        }, required: false
      },
    },
    components: { SelectList, CascaderList, DepartPersonSelect, ReturnVisit, Sessionlab, RadioCheckBox },
    data() {
      return {
        vdnId: '',
        datetimerangeObj: [],
        sForm: {
          title: '',
          orderTypeCode: '',
          formId: '',
          solveSelf: '',
        },
        examineForm: {},
        sessionLabVisible: false,
        isHotlineSubmit: false, //是否弹屏提交
        submitLoading: false,
        sessLabPath: [],
        labelList: [],
        labelIds: [],
        orderInfo: {},
        modelCfgList: [],
        cusLableList: [], //客户标签
        labelSelected: [], //已选择的客户标签
        fileList: [], //附件
        orderFormOption: [],
        formColumnList: [],
        optionList: {},
        filterData: [], //下拉数据集
        userGroupList: [], //当前所属部门
        examineRules: {
          checkRes: [{ required: true, message: this.Language('请选择工单类型') }],
          checkRemark: []
        },
        rules: {
          title: [{ required: true, message: this.Language('请填入标题'), trigger:'blur'}],
          orderTypeCode: [{ required: true, message: this.Language('请选择工单类型'), trigger:'change'}],
          formId: [{ required: true, message: this.Language('请选择表单名称'), trigger:'change'}],
        }
      }
    },
    watch:{
      dialogShow: {
        deep: true,
        handler: function (newV, oldV) {
          this.handleClose()
        },
      },
      sFormInfo: {
        deep: true,
        handler: function (newV, oldV) {
          if (JSON.stringify(this.sFormInfo)!="{}") {
            this.sForm['title'] = this.sFormInfo['title']
            this.sForm['orderTypeCode'] = this.sFormInfo['orderTypeCode']
            this.sForm['formId'] = this.sFormInfo['formId']
            this.sForm['solveSelf'] = this.sFormInfo['solveSelf']
          }
        },
      },
      'sForm.orderTypeCode': function(val) {
        this.orderFormDesignGetListFn(val)
      },
      'sForm.formId': function(val) {
        if (val) {
          this.formColumnList = []
          this.sForm.solveSelf = 0
          this.fetchFormColumnList(val)
        }
      },
      'examineForm.checkRes': function(val) {
        this.$refs.examineForm.clearValidate()
        if (val == 2) this.examineRules['checkRemark'] = [{ required: true, message: this.Language('请输入原因') }]
        else this.examineRules['checkRemark'] = []
      }
    },
    mounted() {
      this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
      this.optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}
      this.orderFormDesignGetListFn()
      if (JSON.stringify(this.sFormInfo)=="{}" && (this.editType=='add'||this.editType=='hotline')) this.fetchFormColumnList()
    },
    created() {
    },
    methods: {
      //工单类型切换
      orderTypeCodeChangeFn(val) {
        let priorityCode = this.$refs['priorityCode']?this.$refs['priorityCode'][0].values:''
        this.sForm.formId = ''
        this.perHandleManCfgGetCfgInfoFn(val, priorityCode)
      },
      //优先级切换
      priorityCodeChange(data, fieldName) {
        this.perHandleManCfgGetCfgInfoFn(this.sForm.orderTypeCode, data)
      },
      //获取预设受理部门、受理人
      perHandleManCfgGetCfgInfoFn(orderTypeCode, priorityCode) {
        if (this.sForm.solveSelf != 1) {
          this.$refs['groupId'][0].values = null
          this.$refs['userId'][0].values = null
          perHandleManCfgGetCfgInfo({
            vdnId: this.vdnId,
            orderTypeCode: orderTypeCode,
            priorityCode: priorityCode
          }).then(res => {
            if (res && res.retCode == 1) {
              let resData = res.data
              if (resData.groupId) {
                this.$refs['groupId'][0].values = resData.groupId
                this.changeOrgFn([resData.groupId], 'none')
              }
              if (resData.userId) this.$refs['userId'][0].values = resData.userId
            }
          })
        }
      },
      //是否解决切换
      changeCloseFn(val) {
        let data = {
          vdnId: this.vdnId,
          userId: JSON.parse(LocalStorage.getItem("obj")).userId
        }
        if (val == 1) {
          this.formColumnList.map(item => {
            if (item.fieldName == 'groupId' || item.fieldName == 'userId') item.isRequired = 1
          })
          if (this.userGroupList.length) {
            this.$refs['groupId'][0].values = this.userGroupList[0].orgId
            this.changeOrgFn([this.userGroupList[0].orgId], 'solveSelf')
          } else {
            getOrgData(data).then(res => {
              if(res && res.retCode == 1){
                this.userGroupList = res.data
                this.$refs['groupId'][0].values = res.data[0].orgId
                this.changeOrgFn([res.data[0].orgId], 'solveSelf')
              }
            })
          }
        } else {
          this.formColumnList.map(item => {
            if (item.fieldName == 'groupId' || item.fieldName == 'userId') item.isRequired = 0
          })
        }
      },
      //关闭页面
      closePageView() {
        this.$parent.handleClose()
      },
      //统一获取下拉框数据
      getDictyFilterData(){
        let paramsSelectData = this.formColumnList.filter(item=>{
          if( item.dataOrigin && item.dataOrigin!='0' ) return item
        })
        let selectParams =  paramsSelectData.map(item=>{ return item.dataOrigin })
        let selectParamsony = Array.from(new Set(selectParams))//去重
        let params = {
          dictTypeCodeList: selectParamsony,
          vdnId: this.vdnId
        }
        getDictMap(params).then((res)=>{ 
          if(res && res.retCode == 1){
            this.filterData = res.data
          }
        })
      },
      //提交审批
      handleExamineFn() {
        this.$refs.examineForm.validate((valid) => {
          if (valid) {
            let params = {
              vdnId: this.vdnId,
              id: this.examineId,
              ...this.examineForm
            }
            orderExtensionApplyHandle(params).then(res => {
              if (res && res.retCode == 1) {
                this.$Msg.success('操作成功');
                this.$parent.handleClose(1)
              }
            })
          }
        })
      },
      //删除标签
      removeSessionLab(item, index) {
        this.sessLabPath.splice(index, 1)
      },
      //选择会话标签点击确定、取消
      fetchLablistFn(type, val, ids) { //type=1:确定2：取消 val:结果集(路径) ids:id数组
        if (type==1) {
          let Arraylist = val.split(';')||[]
          Arraylist.length = Arraylist.length?Arraylist.length-1:0
          this.labelList = val
          this.labelIds = ids
          this.sessLabPath = []
          if (Arraylist.length) {
            Arraylist.map((item, index) => {
              this.sessLabPath.push({ LabPath: item, id: ids[index] })
            })
          }
        }
        this.sessionLabVisible = false
      },
      //切换渠道类型
      originTypeChange(data, fieldName) {
        if (this.$refs['originId']) {
          this.$refs['originId'][0].fetchOriginListFn(data)
        }
      },
      //切换部门
      changeOrgFn(data, type) {
        if (this.$refs['userId']) {
          this.$refs['userId'][0].fetchUserListFn(data, type)
        }
      },
      //获取表单编辑字段信息
      fetchFormColumnList(id) {
        const self = this
        let params = {}
        if (id) {
          params = { vdnId: this.vdnId, formId: id }
        } else {
          params = { vdnId: this.vdnId, configType: 3 }
        }
        getFormColumnList(params).then(res => {
          if(res && res.retCode == 1){
            this.formColumnList = res.data
            if (this.formColumnList.length) {
              this.formColumnList.map((item, index) => {
                if (item.inputType == 'textarea'||item.inputType == 'radio'||item.inputType == 'checkbox'||item.fieldName == 'labMsg') item['width'] = 100
                else item['width'] = 50
                if (item.fieldName == 'labPath') this.formColumnList.splice(index, 1)
                if (item.inputType === 'input' && item.fieldCnName == '上传附件') {
                  item['width'] = 100
                  this.fetchAttList(this.sFormInfo.orderId)
                }
                if (item.fieldName == 'isTipsCus') this.$set(this.sForm, 'isTipsCus', '1')
                if (item.fieldName == 'isVisit') this.$set(this.sForm, 'isVisit', '1')

                //弹屏页面下回填带过来的参数-begin
                if (this.editType == 'hotline') {
                  if (item.fieldName == 'originType') {
                    this.$nextTick(function() {
                      this.$refs[item.fieldName][0].values = this.hotlineObj['originType']
                      this.$refs['originId'][0].fetchOriginListFn(this.hotlineObj['originType'])
                    })
                  }
                  if (item.fieldName == 'originId') {
                    this.$nextTick(function() {
                      this.$refs[item.fieldName][0].values = this.hotlineObj['originId']
                    })
                  }
                  if (item.fieldName == 'vId') this.$set(this.sForm, 'vId', this.hotlineObj['vId'])
                  if (item.fieldName == 'nikeName') this.$set(this.sForm, 'nikeName', this.hotlineObj['nikeName']?this.hotlineObj['nikeName']:this.hotlineObj['vId'])
                  if (item.fieldName == 'sourceId') this.$set(this.sForm, 'sourceId', this.hotlineObj['sourceId'])
                }
                //弹屏页面下回填带过来的参数-end
              })
              this.getDictyFilterData()
            }
            if (this.editType != 'add' && this.editType != 'hotline') {
              setTimeout(function() {
                self.setFormData(self.sFormInfo)
              })
            }
          }
        })
      },
      //工单表单列表
      orderFormDesignGetListFn(id) {
        this.orderFormOption = this.optionList['orderForm']
        if (id) {
          this.orderFormOption = this.orderFormOption.filter(item => {
            return item.orderTypeCode == id
          })
        }
      },
      checkFile(file) {
        let type = file.type
        let name = file.name
        let size = file.size
        // let isXls = type && type === "application/vnd.ms-excel"
        // isXls = name && (name.substring(name.lastIndexOf(".") + 1) === "xls" || name.substring(name.lastIndexOf(".") + 1) === "xlsx")
        // if (!isXls) {
        //   this.$Msg.error("文件格式不合法，请上传xls、xlsx文件")
        //   return false
        // } 
        if (size > 1024 * 1024 * 10) {
          this.$Msg.error("文件过大，请上传10MB以内的文件")
          return false
        }
        return true
      },
      handleBeforeUpload(file) {
        if (!this.checkFile(file)) {
          return false
        }
      },
      handleUploadHttpRequest(content) {
        const self = this
        let resData = []
        let formData = new FormData()
        formData.append("vdnId", self.vdnId)
        formData.append("orderId", self.sFormInfo.orderId)
        formData.append("media", content.file)
        orderUploadFile(formData).then(res => {
          if (res.retCode == 1) {
            resData = res.data
            self.fileList.push({
              name: resData.name,
              path: resData.path,
              id: ''
            })
          }
        })
      },
      handleUploadChange(file, fileList) {
        // this.$refs['uploadFile'][0].clearFiles()
      },
      //删除附件文件
      fileDeleteFn(index) {
        this.fileList.splice(index, 1)
      },
      //模板选择点击事件
      handleNodeClick(data, node, obj, fieldName) {
        this.$refs[fieldName][0].doClose()
        this.$set(this.sForm, fieldName, data['content'])
      },
      //模板列表
      orderModelCfgGetListFn() {
        if (!this.modelCfgList.length) {
          orderModelCfgGetList({
            pageNo: 1,
            pageSize: 9999,
            vdnId: this.vdnId
          }).then((res) => {
            if (res && res.retCode === 1) {
              this.modelCfgList = res.data.list
            }
          })
        }
      },
      getStyle(item) {
        if (item.inputType == 'textarea'||item.inputType == 'radio'||item.inputType == 'checkbox'||item.fieldName == 'labMsg'||(item.inputType === 'input' && item.fieldCnName == '上传附件')) item['width'] = 100
        else item['width'] = 50
        let style = 'width: 100%;display: block;'
        if (item.width == 50) style = 'width: 50%;display: inline-block;'
        else style = 'width: 100%;display: block;'
        style += 'vertical-align: top;'
        return style
      },
      rulesFunc(item){
        if(item.inputType =="select"||item.inputType =="radio"){
          let validateSelect= (rule, value, callback) => {
            let valu = this.$refs[item.fieldName][0].values
            if ((valu instanceof Array && !valu.length) || !valu) {
              return callback(new Error(this.Language('必填')))
            } else {
              return callback()
            }
          }
          return [{ required: true, validator: validateSelect}]
        } else if (item.fieldName == "labMsg") {
          let validateSelect= (rule, value, callback) => {
            if (!this.sessLabPath.length) {
              return callback(new Error(this.Language('必填')))
            } else {
              return callback()
            }
          }
          return [{ required: true, validator: validateSelect}]
        }else{
          return [{ required: true, message: `请填入${item.fieldCnName}`, trigger:'blur'}]
        }
      },
      setFormData(data) {
        this.formColumnList.forEach(row => {
          if((row.inputType === 'select' || row.inputType === 'cascader')&&row.dataOrigin!='is'){
            if (row.fieldName!='orderTypeCode'&&row.fieldName!='formId'&&row.fieldName!='cusId'&&data[row.fieldName]) {
              this.$refs[row.fieldName][0].values = data[row.fieldName]
            }
          } else if (row.inputType === 'datetimerange') {
            this.$set(this.sForm, row.fieldName, data[row.fieldName])
          } else if (row.fieldName == 'labMsg') {
            if (data['labMsg']&&data['labPath']) {
              this.sessLabPath = []
              let labMsg = data['labMsg'].split(',')
              let labPath = data['labPath'].split(',')
              if (labMsg.length) {
                labMsg.map((item, index) => {
                  this.sessLabPath.push({ LabPath: labPath[index], id: item })
                })
              }
            }
          } else if (row.inputType == 'radio') {
            this.$refs[row.fieldName][0].values = data[row.fieldName]
          } else if (row.inputType == 'checkbox') {
            this.$refs[row.fieldName][0].values2 = data[row.fieldName]?JSON.parse(data[row.fieldName]):[]
          } else {
            this.$set(this.sForm, row.fieldName, data[row.fieldName]||'')
          }
				})
        this.$set(this.sForm, 'id', data['id'])
        this.$set(this.sForm, 'cusId', data['cusId'])
      },
      //重置表单
      handleClose() {
        this.sForm = {}
        this.resetFn()
        this.$nextTick(()=>{
          this.$refs.sForm.clearValidate()
        })
      },
			resetFn(){
				this.datetimerangeObj = []
				for (let fild in this.sForm) {
					this.sForm[fild] = null
				}
				this.formColumnList.forEach(row => {
          if(row.inputType === 'select' || row.inputType === 'cascader'){
            this.$refs[row.fieldName][0].values = ''
          }
				})
			},
      //获取附件列表
      fetchAttList(orderId) {
        if (!orderId) return
        getAttList({
          vdnId: this.vdnId,
          orderId: orderId
        }).then(res => {
          if (res && res.retCode == 1) {
            this.fileList = []
            res.data.map(item => {
              this.fileList.push({
                name: item.name,
                path: item.path,
                id: item.id
              })
            })
          }
        })
      },
      saveFn(type) {
        const self = this
        this.$refs.sForm.validate((valid) => {
          if (valid) {
            var refs = this.$refs
            for (let fild in refs) {
              if (fild == 'groupId' && this.$refs[fild][0]) {
                let values = this.$refs[fild][0].values, newValues = []
                if (values) {
                  if (typeof(values) == 'string') newValues = values.split(',')
                  else newValues = values
                  this.sForm[fild] = newValues[newValues.length-1]
                }
              } else if (fild == 'labMsg' && this.$refs[fild][0]) {
                if (this.sessLabPath.length) {
                  let labMsg = [], LabPath = []
                  this.sessLabPath.map(item => {
                    labMsg.push(item.id)
                    LabPath.push(item.LabPath)
                    this.sForm['labMsg'] = labMsg
                    this.sForm['LabPath'] = LabPath
                  })
                }
              } else if (fild != 'sForm' && fild != 'content' && fild != 'handleContent' && this.$refs[fild][0]) {
                this.sForm[fild] = this.$refs[fild][0].values||this.$refs[fild][0].value
              }
            }
            this.formColumnList.forEach(row => {
              if (this.datetimerangeObj[row.fieldName] !=null && this.datetimerangeObj[row.fieldName] !='' && this.datetimerangeObj[row.fieldName] != undefined){
                this.sForm[`${row.fieldName}`] = this.datetimerangeObj[row.fieldName][0]+'~'+this.datetimerangeObj[row.fieldName][1]
              }
            })
            console.log(this.sForm)
            if (!this.sForm.cusId) {
              this.$Msg.error('客户信息未保存！')
            } else {
              //是否暂存
              if (type==1) this.sForm['isCache'] = 1
              else delete this.sForm.isCache
              
              if (self.fileList.length) self.$emit('saveFn', this.sForm, self.fileList)
              else self.$emit('saveFn', this.sForm)
            }
          }
        })
      },
    },
  }
</script>

<style lang="scss">
  .orderSessionLab .el-dialog{
    margin-top: 10vh !important;
    height: 80% !important;
  }
  .orderSessionLab .el-dialog__body{
    height: calc(100% - 85px) !important;
  }
</style>
<style scoped lang="scss">
  .label-list{
    position: relative;
    overflow: hidden;
    .labelItem{
      float: left;
      border-radius: 6px;
      padding: 3px 8px;
      margin: 5px 8px 0 0;
      background: #41C663;
      color: #fff;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
    }
    .labelItem i{
      margin-left: 8px;
      cursor: pointer;
    }
  }
  .fileList{
    margin-bottom: -5px;
    overflow: hidden;
    li{
      position: relative;
      padding-right: 30px;
      float: left;
      height: 25px;
      line-height: 25px;
      font-size: 12px;
      color: #000;
      &:hover .fileDel{
        display: inline-block;
      }
    }
    .fileIcon{
      color: #409EFF;
      margin-right: 5px;
    }
    .fileDel{
      position: absolute;
      right: 10px;
      top: 5px;
      display: none;
      color: red;
      font-size: 14px;
      cursor: pointer;
    }
  }
</style>


// WEBPACK FOOTER //
// OrderForm.vue?4da343ae